/* eslint-disable jsx-a11y/click-events-have-key-events */
import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Check } from '../../assets/images/check.svg';
import { replaceAllSpaces } from '../../lib/utils';
import { User } from '../../models/User';
import { CharacterImage } from '../shared/CharacterImage';
import { IslandName } from '../shared/IslandName';

interface UserListItemProps {
  user: User;
  isSelected?: boolean;
  isChecked?: boolean;
  onUserClick?: (userId: string) => () => void;
}

export const UserListItem: React.FC<UserListItemProps> = ({
  user,
  isSelected,
  isChecked,
  onUserClick
}) => {
  const { t, i18n } = useTranslation('translation');
  const { name, land, image, screening } = user;
  const isReported = screening === 'ng';

  return (
    <li
      className={css`
        padding: 2px 0 0;
        position: relative;
        &:nth-child(n + 2)::after {
          content: '';
          position: absolute;
          top: 0;
          right: 24px;
          left: 24px;
          border-bottom: 2px dashed #dcd8bf;
        }
      `}
      onClick={onUserClick && onUserClick(user.id)}
      key={user.id}
      role="option"
      aria-selected={isChecked}
    >
      <div
        className={css`
          display: flex;
          align-items: center;
          color: black;
          padding: 12px 24px;
          border-radius: 2px;
          color: #938666;
          transition: background 0.1s;
          &:active {
            background: #ece5d4;
          }
          .image {
            flex: 0 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 56px;
            height: 56px;
            margin: 0 12px 0 0;
          }
          .names {
            position: relative;
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0 12px 0 0;
            font-size: 13px;
            overflow: hidden;
            white-space: nowrap;
          }
          .name,
          .land {
            display: block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 18px;
            color: #4d3906;
          }
          .reported {
            font-size: 16px;
          }
          .check {
            flex: 0 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            padding: 0;
            opacity: ${isChecked ? 1 : 0.3};
            visibility: ${isChecked || isSelected ? 'visible' : 'hidden'};
            transform: ${isChecked || isSelected ? 'scale(1)' : 'scale(0)'};
            transition: all 0.2s;
          }
        `}
      >
        <div className="image" aria-hidden={true}>
          <CharacterImage src={image} isPlayer={true} isReported={isReported} />
        </div>
        <div className="names">
          {isReported ? (
            <span className="name reported">{t('reported_player')}</span>
          ) : (
            <>
              <span className="land">
                <IslandName
                  landName={land.name}
                  landDisplayId={land.displayId}
                  language={i18n.language}
                />
              </span>
              <span className="name">{replaceAllSpaces(name)}</span>
            </>
          )}
        </div>
        <span className="check">
          <Check />
        </span>
      </div>
    </li>
  );
};
